import {
	AvailableSlotResponse,
	bookTheSlotPayload,
	GetAvailableSlotPayload,
	rescheduleSlotPayload,
} from "@/store/types/talkToExpertTypes";
import axiosInstance from "@/utils/axiosInstance";
import { buildQueryString2 } from "@/utils/buildQueryString";
import { createAsyncThunk } from "@reduxjs/toolkit";

interface BookTheSlotResponse {
	status: boolean;
}

export const bookTheSlot = createAsyncThunk<
	BookTheSlotResponse,
	bookTheSlotPayload
>("talkToExpert/bookTheSlot", async (payload, { rejectWithValue }) => {
	try {
		await axiosInstance.post(`api/book`, payload);
		return { status: true };
	} catch (e) {
		return rejectWithValue(e);
	}
});

export const rescheduleSlot = createAsyncThunk<
	BookTheSlotResponse,
	rescheduleSlotPayload
>(
	"talkToExpert/rescheduleSlot",
	async ({ id, payload }, { rejectWithValue }) => {
		try {
			await axiosInstance.patch(`api/reschedule/appointment/${id}`, payload);
			return { status: true };
		} catch (e) {
			return rejectWithValue(e);
		}
	}
);

export const getAvailableSlot = createAsyncThunk<
	AvailableSlotResponse,
	GetAvailableSlotPayload
>("talkToExpert/getAvailableSlot", async (payload, { rejectWithValue }) => {
	try {
		const { data } = await axiosInstance.get(
			`api/slots?${buildQueryString2(payload)}`
		);

		return {
			list: data.data,
			counsellorId: data.counsellorId,
			total: data.data.length,
		};
	} catch (e) {
		return rejectWithValue(e);
	}
});
